import { styled } from '@styles/stitches';

export const SVG = styled('svg', {
  display: 'block',
});

export const Background = styled('circle', {
  fill: '$primaryFill',
});

export const Circle = styled('circle', {
  fill: 'transparent',
  stroke: '$primaryBackground',
});

export const G = styled('g', {
  transformBox: 'fill-box',
  transformOrigin: 'center',
  transform: 'rotate(0deg)',
});

export const Path = styled('path', {
  fill: '$primaryFill',
});
